import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { useAddAliasLinkMutation, useAliasLinksQuery } from "@/common/queries/queries";
import { IAliasLink, IErrorData } from "@/common/services/types";
import { DEFAULT_ERROR, VERIFIED_ERROR, LinksErrorCodes } from "./constants";
import { ManageLinks } from "components/manage/ManageLinks/ManageLinks";
import { showNotification } from "@/components/alerts/Notifications";

interface IManageLinksContainer {
  gifId: string;
}

export const ManageLinksContainer: React.FC<IManageLinksContainer> = ({
  gifId
}) => {
  const [aliasIds, setAliasIds] = useState<IAliasLink[]>([]);
  const { isSuccess, data } = useAliasLinksQuery(gifId);
  const addAliasLink = useAddAliasLinkMutation(gifId);

  useEffect(() => {
    if (isSuccess && data) {
      setAliasIds(data);
    }
  }, [isSuccess, data]);

  const handleAddLinkError = (error: unknown) => {
    const axiosError = error as AxiosError<IErrorData>;
    const errorData = axiosError.response?.data?.error;
    const errorMessage = errorData?.message || DEFAULT_ERROR;
    const isVerifiedError = errorData?.code === LinksErrorCodes.AccountNotVerified;

    console.error(errorMessage);

    showNotification({
      title: isVerifiedError ? VERIFIED_ERROR : errorMessage,
      variant: "error"
    });
  };

  const onAddLink = async () => {
    try {
      const alias = await addAliasLink.mutateAsync();
      setAliasIds(prev => [...prev, alias]);
    } catch (err) {
      handleAddLinkError(err);
    }
  };

  return (
    <ManageLinks onAddLink={onAddLink} aliasIds={aliasIds} />
  );
};
